import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import { OrdersListState, Order } from 'common-ts/dist/models/Orders';
import { RootState } from '../store';
import { terbebasClient } from '../terbebasApi';

// Define the initial state using that type
const initialState: OrdersListState = {
  ordersList: [],
  paidOrderCount: 0,
  status: APIRequestStatus.Idle,
  error: null,
}

// Maps a terbebas financial status onto the legacy paymentStatus strings
// the account UI switches on.
function mapPaymentStatus(financialStatus: string): string {
  switch (financialStatus) {
    case 'PAID': return 'settlement';
    case 'PENDING': return 'unpaid';
    case 'REFUNDED':
    case 'PARTIALLY_REFUNDED':
    case 'VOIDED': return 'abandoned';
    default: return 'pending';
  }
}

const FULFILLMENT_TEXT: { [key: string]: string } = {
  UNFULFILLED: 'Sedang diproses',
  PARTIAL: 'Sebagian dikirim',
  FULFILLED: 'Sedang dikirim',
  SHIPPED: 'Sedang dikirim',
  DELIVERED: 'Sudah diterima',
  RETURNED: 'Dikembalikan',
};

// Fetches the signed-in shopper's orders from terbebas-backend and maps
// them onto the (subset of the) legacy Order shape the account UI reads.
export const fetchOrdersList = createAsyncThunk('ordersList/fetchOrdersList',
async (payload, thunkAPI) => {
  const rootState = (thunkAPI.getState() as RootState);
  const idToken = rootState.account.idToken;
  if (!idToken) {
    return { orders: [] };
  }

  const response = await terbebasClient.get('/storefront/my-orders', {
    headers: { 'Authorization': 'Bearer ' + idToken },
  });
  return response.data;
})

export const orderSlice = createSlice({
  name: 'ordersList',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(fetchOrdersList.pending, (state, action) => {
        state.status = APIRequestStatus.RequestInProgress;
      })
      .addCase(fetchOrdersList.fulfilled, (state, action) => {
        const orders: any[] = action.payload.orders ?? [];
        // Backend returns newest first; the account page reverses again.
        state.ordersList = orders.slice().reverse().map((o) => ({
          orderId: o.id,
          orderNumberDisplay: '#' + o.orderNumber,
          paymentStatus: mapPaymentStatus(o.financialStatus),
          estimasiPengiriman: FULFILLMENT_TEXT[o.fulfillmentStatus] ?? o.fulfillmentStatus,
          totalDisplay: o.total,
          createdAt: o.createdAt,
          items: o.items,
        }) as unknown as Order);
        state.paidOrderCount = orders.filter((o) => o.financialStatus === 'PAID').length;
        state.status = APIRequestStatus.Success;
      })
      .addCase(fetchOrdersList.rejected, (state, action) => {
        state.status = APIRequestStatus.Failure;
        console.log("fetch is failure");
      })
  }
})

export default orderSlice.reducer
